/**
 * document-title — eine einzige Stelle, die `document.title` zusammensetzt.
 *
 * Zwei Quellen speisen den Titel, asynchron und unabhängig voneinander:
 *  - der Router (`afterEach`) liefert den SEITEN-Namen ("Kataloge", "Konto" …)
 *  - das Branding (`applyBranding`) liefert den KUNDEN-Namen ("LGH Produktkatalog")
 *
 * Ohne Branding ist der Suffix das Standard-Produkt ("miraCMS 2.0"); im
 * gebrandeten Kunden-Kiosk wird daraus z.B. "Kataloge — LGH Produktkatalog".
 * Beide Setter rendern neu, damit die Reihenfolge der (async) Aufrufe egal ist.
 *
 * Der Seiten-Name kommt als Schlüssel (`route.meta.titel`) und wird erst hier
 * übersetzt, bei jedem Sprachwechsel neu. Bis zum 08.10.2026 stand er deutsch
 * im Router, und ein englischer Zugang las „Bearbeiten" im Browser-Tab.
 */
import { watch } from 'vue'
import i18n from '@/locales'
import { uebersetze } from '@/lib/uebersetzen'

const DEFAULT_SUFFIX = 'miraCMS 2.0'

let titelSchluessel = 'nav.editor'
/** Ein fester Name statt des Schlüssels: der Titel einer Sammlung, der Name der Kundenseite. */
let festerName: string | null = null
let brandName: string | null = null

function render(): void {
  const suffix = brandName || DEFAULT_SUFFIX
  document.title = `${festerName ?? uebersetze(titelSchluessel)} — ${suffix}`
}

/** Seitenname als Schlüssel (aus `route.meta.titel`). */
export function setBaseTitle(schluessel: string | undefined): void {
  titelSchluessel = schluessel ?? 'nav.editor'
  festerName = null
  render()
}

/** Seitenname, der so bleibt, wie er ist: Er kommt aus den Daten des Kunden. */
export function setBaseName(name: string): void {
  festerName = name
  render()
}

/** Kundenname (aus Branding `app_name`). `null`/leer → Standard-Produktname. */
export function setBrandName(name: string | null | undefined): void {
  brandName = name || null
  render()
}

watch(() => (i18n.global.locale as unknown as { value: string }).value, render)
